(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["boogie-films"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('boogie-film')) customElements.define('boogie-film', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.querySelector('button')?.addEventListener('click', event => {
        const content = this.querySelector('template')?.content.cloneNode(true);
        if (!content) return;
        event.currentTarget.replaceWith(content);
        this.querySelector('iframe')?.focus();
      }, { signal, once: true });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boogie-header"]) return;
  try {
    
  document.addEventListener('click', event => {
    document.querySelectorAll('.boogie-site-mobile-menu[open]').forEach(menu => {
      if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = document.querySelector('.boogie-site-mobile-menu[open]');
    if (menu) { menu.open = false; menu.querySelector('summary').focus(); }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boogie-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('boogie-hero')) customElements.define('boogie-hero', class extends HTMLElement {
    connectedCallback() {
      const video = this.querySelector('video');
      if (video && matchMedia('(prefers-reduced-motion: reduce)').matches) {
        video.autoplay = false;
        video.pause();
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boogie-shop"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('boogie-shop')) {
    customElements.define('boogie-shop', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        if (this.hasAttribute('data-group-garments')) this.loadGarmentPages(signal);
        const previewId = new URL(window.location.href).searchParams.get('preview_theme_id');
        if (previewId) {
          this.querySelectorAll('a[href]').forEach(link => {
            const url = new URL(link.href, window.location.origin);
            if (url.origin === window.location.origin && !url.hash) {
              url.searchParams.set('preview_theme_id', previewId);
              link.href = url.href;
            }
          });
          this.querySelectorAll('form').forEach(form => {
            if (form.querySelector('[name="preview_theme_id"]')) return;
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'preview_theme_id';
            input.value = previewId;
            form.append(input);
          });
        }
        this.querySelector('[data-boogie-sort]')?.addEventListener('change', event => event.target.form.requestSubmit(), { signal });
        this.querySelector('.boogie-search')?.addEventListener('toggle', event => {
          if (event.target.open) event.target.querySelector('input[type="search"]')?.focus();
        }, { signal });
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape') {
            const search = this.querySelector('.boogie-search[open], .boogie-category-picker[open]');
            if (search) {
              search.open = false;
              search.querySelector('summary').focus();
            }
          }
        }, { signal });
      }
      async loadGarmentPages(signal) {
        let next = this.querySelector('[data-boogie-group-next]');
        if (!next) return;
        const grid = this.querySelector('.boogie-grid');
        const cards = [...grid.querySelectorAll('.boogie-card')];
        const ids = new Set(cards.map(card => card.dataset.productId));
        grid.setAttribute('aria-busy', 'true');
        try {
          while (next) {
            const url = new URL(next.getAttribute('href'), window.location.origin);
            url.searchParams.set('section_id', this.dataset.sectionId);
            url.searchParams.set('sort_by', 'manual');
            const response = await fetch(url, { signal });
            if (!response.ok) throw new Error('Catalog page unavailable');
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const catalog = doc.querySelector('boogie-shop[data-group-garments]');
            if (!catalog) throw new Error('Catalog response unavailable');
            catalog.querySelectorAll('.boogie-card').forEach(card => {
              if (!ids.has(card.dataset.productId)) { ids.add(card.dataset.productId); cards.push(card); }
            });
            next = catalog.querySelector('[data-boogie-group-next]');
          }
          cards.sort((a, b) => a.dataset.garmentGroup.localeCompare(b.dataset.garmentGroup) || a.dataset.productTitle.localeCompare(b.dataset.productTitle));
          grid.replaceChildren(...cards);
          this.querySelector('.boogie-pagination')?.remove();
          this.querySelector('[data-boogie-group-next]')?.remove();
        } catch (error) {
          if (error.name !== 'AbortError') grid.removeAttribute('aria-busy');
        } finally { grid.removeAttribute('aria-busy'); }
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
